export const BASE_QUERY_CONFIG = {
  // 403 is deliberately not here: the backend uses it for "caller is not allowed to do this"
  // (not the card owner, foreign company card, order rejected for this company, …) while the
  // session is still valid. Logging out on it bounced users through Home's auto sign-in, which
  // silently re-authenticated them and PublicRoute dropped them on /user-profile.
  logoutOnErrorCodes: [419],
  maxRefreshAttempts: 3,
  retryDelayBase: 1000,
};
